<template>
  <el-dialog :title="title" :visible="visible" width="600px" :before-close="handleClose">
    <el-carousel :autoplay="false" indicator-position="none" height="400px">
      <el-carousel-item v-for="item in detailVOList"
                        v-if="item.orderGoodsDetailStatus == 0 && !item.refundOrderId"
                        :key="item.orderGoodsDetailNo">
        <div class="qrcode-item-ch">
          <div class="qrcode-item-no">{{ item.orderGoodsDetailNo }}</div>
          <QrCode :text="item.orderGoodsDetailNo"></QrCode>
        </div>
      </el-carousel-item>
    </el-carousel>
    <p style="text-align:center">您也可移步至微信小程序查看提货码</p>
    <div slot="footer">
      <el-button type="primary" @click="$emit('update:visible', false)">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import QrCode from "@/components/base/QrCode";

export default {
  props: {
    title: {
      type: String,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    detailVOList: {
      type: Array,
      default: () => [],
    },
  },
  components: {QrCode},
  data() {
    return {};
  },
  computed: { },
  created() {
  },
  mounted() {
  },
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
    async confirm() {
      // this.$refs["form"].validate(async (valid) => {
      //   if (valid) {
      //     await this.$api.updateRewardScore({ ...this.form });
      //     this.$message.success("操作成功");
      //     this.$emit("dialogCallback");
      //     this.$emit("update:visible", false);
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.qrcode-item-ch {
  text-align: center;

  img {
    width: 300px;
    margin: 0 auto;
  }

  .qrcode-item-no {
    color: #333;
    margin-bottom: 30px;
    font-size: 18px;
  }
}
</style>
